const title = process.env.VUE_APP_proTitle || '盼之代售'

export default function getPageTitle(pageTitle) {
    if (pageTitle) {
        return `${pageTitle} • ${title}`
    }
    return `${title}`
}
